export default __webpack_public_path__ + "static/media/qualigrad_logo.9d443ab6.png";